import { render } from "./ShortcutView.vue?vue&type=template&id=643b0674&scoped=true"
import script from "./ShortcutView.vue?vue&type=script&lang=js"
export * from "./ShortcutView.vue?vue&type=script&lang=js"

import "./ShortcutView.vue?vue&type=style&index=0&id=643b0674&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643b0674"]])

export default __exports__